import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ReloadTable from "../components/baseComponent/ReloadTable";
import ReloadForm from "../components/baseComponent/ReloadForm";

const Reload = () => {
    const navigate = useNavigate();
    const [isModelBoxOpen, setIsModelBoxOpen] = useState(false);

    const handleModelBoxClick = () => {
        setIsModelBoxOpen(true);
        navigate("/admin/reloadform");
    };

    const handleCloseModal = () => {
        setIsModelBoxOpen(false);
        navigate("/admin/reload");
    };

    return (
        <div className="main-inner-wrapper leavemenu-wrapper">
            <div className="px-4">
                <div className="leave-apply__wrapper p-4 bg-white dark:bg-neutral-800 border border-gray-300 dark:border-gray-500 rounded-xl">
                    <div className="flex justify-between gap-4 mb-6">
                        <h1 className="incident-report-heading m">Reload</h1>
                        <button
                            className="py-2 px-3 addIncidentDetailsBtn text-white text-xs font-semibold rounded-md shadow focus:outline-none"
                            onClick={handleModelBoxClick}
                        >
                            Add Reload Details
                        </button>
                    </div>

                    <ReloadTable />
                </div>
            </div>
            {isModelBoxOpen && (
                <div className="modal-overlay">
                    <div className="modal">
                        <button className="modal-close" onClick={handleCloseModal}>
                            Close
                        </button>
                        <ReloadForm onSubmit={handleCloseModal} />
                    </div>
                </div>
            )}
        </div>
    );
};

export default Reload;
